import React, { useContext, useEffect, useState } from 'react'
import { Button } from '@material-tailwind/react'
import { AiOutlineControl, AiOutlinePlusSquare } from 'react-icons/ai'
import { NewContext } from '../../Context/NewContext'
import PerpageAndDeleteBtn from '../PerpageAndDeleteBtn/PerpageAndDeleteBtn'
import { MdOutlineArrowBackIosNew, MdOutlineCloudUpload } from 'react-icons/md'
import { Space, DatePicker } from 'antd';
import { LiaFileDownloadSolid } from "react-icons/lia";
import { download_feedback_excel, download_rating_excel, get_Feedbackcategory_Setting } from '../../Controller/actions'
import { Switch } from '../../Components';
const { RangePicker } = DatePicker;

export const SearchAndAddBtn = ({ backBtn = false, updateBtn = false, datePicker = false, isSearch = true, title, addBtn = true, countryFilter = true, recommendedLoading = false, FilterDropdowns, delBtn, perPageCount, deleteUpdateTag, redirectionBtn = false, resetFilterBtn, adsControlBtn = false, excelBtn = false, addJsonBtn = false }) => {
    const { setCheckedValues, currentUserId, setCurrentUserId, setCurrentHomeModalKey, setAddEditDeleteTag, deleteUpdateYes, homeScreenData, setFormData, setDeleteUpdateYes, search, setSearch, setCurrentPage, handleOpen, handleSwitchUpdate, handleChildOpen, setConfirmationModalShow, setDeleteUpdateItem, setSelectedDates, selectedDates, filterDropdown, currentPageData, deleteUpdateItem } = useContext(NewContext);
    const [updateValue, setUpdateValue] = useState(false);
    useEffect(() => {
        if (deleteUpdateYes === "update-sectionsettings-priority") {
            let newAry = homeScreenData && homeScreenData.map((_ele, i) => ({ _id: _ele._id, priority: _ele.priority }));
            setDeleteUpdateItem({ updates: newAry });
        }
    }, [deleteUpdateYes, homeScreenData]);

    const getFeedbackSettingData = async () => {
        const getFeedbackSettingData = await get_Feedbackcategory_Setting()
        if (getFeedbackSettingData) {
            const { status, data } = getFeedbackSettingData;
            if (status) {
                setUpdateValue(data.json);
            } else {
                setUpdateValue(false);
            }
        }
    }
    useEffect(() => {
        getFeedbackSettingData()
    }, [])


    const handleDateChange = (dates, dateStrings) => {
        setSelectedDates(dateStrings);
    };
    const downloadExcel = async () => {
        try {
            const [startDate, endDate] = selectedDates;
            let getExcelData
            if (title === 'Feedback') {
                getExcelData = await download_feedback_excel(filterDropdown, search, startDate, endDate)
            } else {

                getExcelData = await download_rating_excel(filterDropdown, search, startDate, endDate)
            }
            const blob = new Blob([getExcelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = title === 'Feedback' ? 'feedback.xlsx' : 'rating.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className={`mb-4 flex items-center gap-0 sm:gap-2 2xl:gap-0 flex-wrap ${title ? `justify-between` : `justify-end`}`}>

            <div className='flex flex-wrap gap-2 lg:gap-2 2xl:gap-0 items-center'>

                {
                    currentUserId && <button className='mr-3' onClick={() => { setCurrentUserId(''); setCheckedValues([]); }} ><MdOutlineArrowBackIosNew className='text-2xl' /></button>
                    // isShown ? <button className='mr-3' onClick={() => setIsShown(false)} ><MdOutlineArrowBackIosNew className='text-2xl' /></button> : ""
                }

                {
                    title && <div className='mr-5 lg:mr-0 2xl:mr-5'>
                        <h2 className={`font-medium text-[24px] text-[#1E1627] leading-none`}>{title}</h2>
                    </div>
                }

                <div className='flex flex-wrap gap-2 lg:gap-2 items-center'>
                    <PerpageAndDeleteBtn delBtn={delBtn} resetFilterBtn={resetFilterBtn} deleteUpdateTag={deleteUpdateTag} perPageCount={perPageCount} />
                    {
                        FilterDropdowns && FilterDropdowns
                    }
                </div>
                <div >
                    {
                        datePicker &&
                        <Space className='flex lg:px-2 w-[275px] lg:w-[267px] space-x-2 xl:space-x-4 rounded-lg ' direction="vertical" size={12}>
                            <RangePicker className="px-3 py-3 bg-white border border-[#BCC2CC]" renderExtraFooter={() => 'extra footer'}
                                onChange={handleDateChange}
                            />
                        </Space>
                    }
                </div>
                <div>
                    {
                        excelBtn && currentPageData?.length > 0 && <Button
                            className='lg:ml-2.5 lg:px-4 2xl:px-5 flex items-center bg-[#0047FF] capitalize text-sm leading-none font-medium whitespace-nowrap shadow-none hover:shadow-none'
                            onClick={() => { downloadExcel() }}>
                            Download Excel <LiaFileDownloadSolid size={"22px"} className='ml-2.5' />
                        </Button>
                    }
                </div>
                {/* <div>
                    {
                        addJsonBtn && <div className=' items-center'> <label htmlFor=""> Json </label> <div className=''> <Switch onChange={(e) => { setDeleteUpdateYes("update-feedback-category"); handleSwitchUpdate(e); }} /></div></div>
                    }
                </div> */}
            </div>

            <div className="flex flex-wrap gap-2 mt-2 lg:mt-0 mx-auto xs:mx-0">
                {/* <Input containerProps={{ className: "h-12 w-[367px]" }} labelProps={{ className: "top-0 h-full" }} icon={<MagnifyingGlassIcon className="h-5 w-5" />} label="Search Item" /> */}
                {
                    addJsonBtn && <div className='mr-5 lg:mr-0 2xl:mr-5'>
                        <label htmlFor=""> Json </label>
                        <div className='flex-row'>
                            <Switch name={'json'}
                                checked={updateValue}
                                id='isActive'
                                onChange={(e) => {
                                    setDeleteUpdateYes("update-feedback-category-setting");
                                    handleSwitchUpdate(e);
                                }} />
                        </div>
                    </div>
                }
                {
                    isSearch &&
                    <div className="flex bg-white py-3 px-[15px] lg:px-2 w-[275px] lg:w-[267px] space-x-2 xl:space-x-4 rounded-lg border border-[#BCC2CC]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 opacity-30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            className="bg-white outline-none w-full"
                            type="text"
                            placeholder={`Search ${title}`}
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); setCurrentPage(1) }}
                        />
                    </div>
                }
                {
                    redirectionBtn &&
                    <Button
                        className='lg:ml-2.5 lg:px-4 2xl:px-5 flex items-center bg-[#0047FF] capitalize text-sm leading-none font-medium whitespace-nowrap shadow-none hover:shadow-none'
                        onClick={() => {
                            setDeleteUpdateYes(`add`);
                            setCurrentHomeModalKey(`add`);
                            setFormData({});
                            handleOpen();
                        }}>
                        Redirections <AiOutlinePlusSquare size={"22px"} className='ml-2.5' />
                    </Button>
                }
                {
                    adsControlBtn &&
                    <Button
                        className='lg:ml-2.5 lg:px-4 2xl:px-5 flex items-center bg-[#0047FF] capitalize text-sm leading-none font-medium whitespace-nowrap shadow-none hover:shadow-none'
                        onClick={() => {
                            setAddEditDeleteTag(`update-settings`)
                            handleChildOpen();
                        }}
                    >
                        Ads Control<AiOutlineControl size={"22px"} className='ml-2.5' />
                    </Button>
                }
                {
                    addBtn &&
                    <Button
                        className='lg:ml-2.5 lg:px-4 2xl:px-5 flex items-center bg-[#0047FF] capitalize text-sm leading-none font-medium whitespace-nowrap shadow-none hover:shadow-none'
                        onClick={() => {
                            setDeleteUpdateYes(`add`);
                            setAddEditDeleteTag(`add`);
                            setCurrentHomeModalKey(`add`);
                            setFormData({});
                            handleOpen();
                        }}
                    >
                        Add New {title} <AiOutlinePlusSquare size={"22px"} className='ml-2.5' />
                    </Button>
                }{
                    updateBtn &&
                    <Button
                        className='lg:ml-2.5 flex items-center bg-[#0047FF] capitalize text-sm leading-none font-medium whitespace-nowrap shadow-none hover:shadow-none'
                        onClick={() => {
                            setDeleteUpdateYes("update-sectionsettings-priority");
                            setConfirmationModalShow(true)
                        }}
                    >
                        Update<MdOutlineCloudUpload size={"22px"} className='ml-2.5' />
                    </Button>
                }
            </div>
        </div >
    )
}

export default SearchAndAddBtn